module.exports = __webpack_public_path__ + "img/Logo.e5a73563.png";